export default __webpack_public_path__ + "static/partner-rainbow-3c9908f242cb0c741565c6fe2c2135d4.svg";